export default function Location() {
  return (
    <section id="location" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Hamare Shop Ka Location
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Sikandrabad mein aayein aur apne electronics theek karwayen
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-map-pin-fill text-orange-500 text-3xl"></i>
                Shop Address
              </h3>
              <div className="space-y-4 text-gray-700">
                <p className="text-lg leading-relaxed">
                  <strong>Sunil Electronics</strong><br />
                  Chamber ki Dharamshala,<br />
                  Sikandrabad, Bulandshahr,<br />
                  Uttar Pradesh – 203205
                </p>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-time-fill text-orange-500 text-3xl"></i>
                Shop Timing
              </h3>
              <p className="text-lg text-gray-700">
                <strong>Daily:</strong> 10:00 AM – 10:00 PM
              </p>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-phone-fill text-orange-500 text-3xl"></i>
                Contact Us
              </h3>
              <div className="space-y-3">
                <a 
                  href="tel:9927256718"
                  className="flex items-center gap-3 text-lg text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>Call: 9927256718</span>
                </a>
                <a 
                  href="https://wa.me/919927256718"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-lg text-gray-700 hover:text-green-500 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>WhatsApp: 9927256718</span>
                </a>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-map-2-line text-orange-500 text-3xl"></i>
                Service Area
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Customers visit from Sikandrabad, Bulandshahr and nearby areas
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <a
              href="https://maps.app.goo.gl/5GZtHgFsuoPadPtj6"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold text-lg px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-map-pin-line text-2xl"></i>
              <span>Get Directions</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
            <p className="text-gray-600 text-sm mt-4">
              Click to open in Google Maps
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
